<template>
  <Dialog v-model:visible="visible" modal :header="detailDialogHeader" class="insights-dialog insights-dialog--detail" @hide="onHide">
    <div v-if="isAutofit" class="details-table-shell">
      <DataTable class="insights-data-table" :value="data" paginator :rows="10" :rowsPerPageOptions="[10, 15, 20]" removableSort tableStyle="min-width: 50rem" :rowHover="true"
        selectionMode="single" dataKey="id" @rowSelect="onRowSelect" @rowUnselect="onRowUnselect" v-model:selection="selectId" :metaKeySelection="false">
        <template #header>
          <div class="vlecad-table-toolbar">
            <MultiSelect v-model="selectedColumnFields" :options="columns" optionLabel="header" optionValue="field" display="chip" :placeholder="$t('detail.selectColumns')" />
            <Button icon="pi pi-external-link" :label="$t('detail.export')" @click="exportCSV($event)" />
          </div>
        </template>
        <Column v-for="(col, index) in selectedColumns" :field="col.field" :header="col.header" :key="col.field + '_' + index" sortable></Column>
      </DataTable>
    </div>
    <div v-else class="details-table-shell">
      <DataTable class="insights-data-table" :value="data" paginator :rows="10" :rowsPerPageOptions="[10, 15, 20]" removableSort tableStyle="min-width: 50rem" :rowHover="true"
        selectionMode="single" dataKey="id" @rowSelect="onRowSelect" @rowUnselect="onRowUnselect" v-model:selection="selectId" :metaKeySelection="false">
        <template #header>
          <div class="vlecad-table-toolbar">
            <MultiSelect v-model="selectedColumnFieldsKorpus" :options="columnsKorpus" optionLabel="header" optionValue="field" display="chip" :placeholder="$t('detail.selectColumns')" />
            <Button icon="pi pi-external-link" :label="$t('detail.export')" @click="exportCSV($event)" />
          </div>
        </template>
        <Column v-for="(col, index) in selectedColumnsKorpus" :field="col.field" :header="col.header" :key="col.field + '_' + index" sortable></Column>
      </DataTable>
    </div>
    <span v-if="showError" class="error">{{ message }}</span>
  </Dialog>
  <Dialog v-model:visible="visibleOverzicht" modal :header="$t('detail.materialOverview')" class="insights-dialog insights-dialog--detail" @hide="onHideOverzicht">
    <div v-if="isAutofit">
      <div class="content">
        <div class="content-gray">
          <div class="content-gray-top">
            <ChartComponent id="myChart" :type="doughnutChart.type" :data="doughnutChart.data" :options="doughnutChart.options"/>
          </div>
          <div class="content-gray-bottom">
            <DataTable class="insights-data-table detail-overview-table" :value="resultArray" ref="dt" paginator :rows="5" :rowsPerPageOptions="[5, 10, 15]" showGridlines removableSort>
              <template #header>
                <div class="vlecad-table-toolbar">
                  <MultiSelect v-model="selectedColumnFieldsOverview" :options="columnsOverzicht" optionLabel="header" optionValue="field" display="chip" :placeholder="$t('detail.selectColumns')" />
                  <Button icon="pi pi-external-link" :label="$t('detail.export')" @click="exportCSVOverzicht($event)" />
                </div>
              </template>
              <Column v-for="(col, index) in selectedColumnsOverzicht" :field="col.field" :header="col.header" :key="col.field + '_' + index" sortable></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="content">
        <div class="content-gray">
          <div class="content-gray-top">
            <ChartComponent :type="doughnutChartKorpus.type" :data="doughnutChartKorpus.data" :options="doughnutChartKorpus.options"/>
          </div>
          <div class="content-gray-bottom">
            <DataTable class="insights-data-table detail-overview-table" :value="resultArray" ref="dt" paginator :rows="10" :rowsPerPageOptions="[5, 10, 15]" showGridlines removableSort>
              <template #header>
                <div class="vlecad-table-toolbar">
                  <MultiSelect v-model="selectedColumnFieldsOverviewKorpus" :options="columnsOverzichtKorpus" optionLabel="header" optionValue="field" display="chip" :placeholder="$t('detail.selectColumns')" />
                  <Button icon="pi pi-external-link" :label="$t('detail.export')" @click="exportCSVOverzicht($event)" />
                </div>
              </template>
              <Column v-for="(col, index) in selectedColumnsOverzichtKorpus" :field="col.field" :header="col.header" :key="col.field + '_' + index" sortable></Column>
            </DataTable>
          </div>
        </div>
      </div>
    </div>
    <span v-if="showError" class="error">{{ message }}</span>
  </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from "primevue/button";
import axios from "axios";
import MultiSelect from 'primevue/multiselect';
import ChartComponent from "@/components/ChartComponent.vue";

export default {
  components: { Dialog, DataTable, Column, Button, MultiSelect, ChartComponent },
  props: {
    show: Boolean,
    headerDetail: String
  },
  emits: ['update:show', 'close'],
  data() {
    return {
      visible: this.show,
      visibleOverzicht: false,
      headerDet: this.headerDetail,
      data: [],
      selectId: null,
      resultArray: [],
      isAutofit: true,
      showError: false,
      errorKey: "",
      columnDefinitions: [{field: 'id', labelKey: 'id'}, {field: 'client', labelKey: 'client'}, {field: 'total_qty', labelKey: 'parts'}, {field: 'recordCount', labelKey: 'boards'}, {field: 'commission', labelKey: 'commission'}],
      selectedColumnFields: ['client', 'total_qty', 'recordCount', 'commission'],
      columnDefinitionsKorpus: [{field: 'id', labelKey: 'id'}, {field: 'client', labelKey: 'client'}, {field: 'total_qty', labelKey: 'parts'}, {field: 'commission', labelKey: 'commission'}],
      selectedColumnFieldsKorpus: ['client', 'total_qty', 'commission'],
      columnDefinitionsOverview: [{field: 'materialName', labelKey: 'materialName'}, {field: 'thickness', labelKey: 'thickness'}, {field: 'recordCount', labelKey: 'boards'},
        {field: 'uniqueDocumentIds', labelKey: 'jobs'}, {field: 'uniqueMachines', labelKey: 'machines'}, {field: 'onderdelen', labelKey: 'parts'}],
      selectedColumnFieldsOverview: ['materialName', 'thickness', 'recordCount', 'uniqueDocumentIds', 'uniqueMachines', 'onderdelen'],
      columnDefinitionsOverviewKorpus: [{field: 'materialName', labelKey: 'materialName'}, {field: 'thickness', labelKey: 'thickness'}, {field: 'recordCount', labelKey: 'parts'},
        {field: 'uniqueDocumentIds', labelKey: 'jobs'}, {field: 'productionmethod', labelKey: 'productionMethod'}],
      selectedColumnFieldsOverviewKorpus: ['materialName', 'thickness', 'recordCount', 'uniqueDocumentIds', 'productionmethod'],
      net: 0,
      rest: 0,
      scrap: 0,
      cutting: 0,
      labelsDoughnutKorpus: [],
      dataDoughnutKorpus: []
    }
  },
  computed: {
    detailDialogHeader() {
      return this.headerDet || this.$t('detail.titleGeneric');
    },
    columns() {
      return this.localizeColumns(this.columnDefinitions);
    },
    selectedColumns() {
      return this.columns.filter(column => this.selectedColumnFields.includes(column.field));
    },
    columnsKorpus() {
      return this.localizeColumns(this.columnDefinitionsKorpus);
    },
    selectedColumnsKorpus() {
      return this.columnsKorpus.filter(column => this.selectedColumnFieldsKorpus.includes(column.field));
    },
    columnsOverzicht() {
      return this.localizeColumns(this.columnDefinitionsOverview);
    },
    selectedColumnsOverzicht() {
      return this.columnsOverzicht.filter(column => this.selectedColumnFieldsOverview.includes(column.field));
    },
    columnsOverzichtKorpus() {
      return this.localizeColumns(this.columnDefinitionsOverviewKorpus);
    },
    selectedColumnsOverzichtKorpus() {
      return this.columnsOverzichtKorpus.filter(column => this.selectedColumnFieldsOverviewKorpus.includes(column.field));
    },
    message() {
      return this.errorKey ? this.$t(`detail.errors.${this.errorKey}`) : "";
    },
    doughnutChart() {
      return {
        type: "doughnut",
        data: {
          labels: [this.$t('detail.chart.net'), this.$t('detail.chart.rest'), this.$t('detail.chart.cuttingWaste'), this.$t('detail.chart.waste')],
          datasets: [
            {
              data: [this.net, this.rest, this.cutting, this.scrap],
              backgroundColor: ["#0D74AC", "#BF9C59", "#12364A", "#8FB7C9"],
              hoverBackgroundColor: ["#095F8D", "#D5BE8D", "#243F4E", "#6E9EB5"],
            }
          ]
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
            },
          },
        },
      };
    },
    doughnutChartKorpus() {
      return {
        type: "doughnut",
        data: {
          labels: this.labelsDoughnutKorpus,
          datasets: [
            {
              data: this.dataDoughnutKorpus
            }
          ]
        },
        options: {
          responsive: false,
          plugins: {
            legend: {
              position: "bottom",
            },
            tooltip: {
              callbacks: {
                label(context) {
                  return `${context.raw} %`;
                }
              }
            }
          },
        },
      };
    }
  },
  watch: {
    show(newValue) {
      this.visible = newValue;
      if(newValue) {
        this.getDetailsData();
      }
    },
    headerDetail(newValue) {
      console.log("wacht headerDetail: "+newValue);
      this.headerDet = newValue;
    }
  },
  methods: {
    localizeColumns(definitions) {
      return definitions.map(column => ({
        ...column,
        header: this.$t(`detail.fields.${column.labelKey}`)
      }));
    },
    setError(key) {
      this.errorKey = key;
      this.showError = true;
    },
    clearError() {
      this.errorKey = "";
      this.showError = false;
    },
    exportCSVOverzicht() {
      console.log("exportCSVOverzicht");
      this.clearError();
      const now = new Date();
      const offset = now.getTimezoneOffset(); // Offset in minutes
      const localTime = new Date(now.getTime() - offset * 60000); // Convert UTC to local
      const formattedDate = localTime.toISOString().slice(0, 19).replace("T", "_").replace(/:/g, "-");
      const filename = `${this.$t('detail.exportFilename')}_${formattedDate}`;
      console.log("filename: " + filename);

      if (!this.resultArray || this.resultArray.length === 0) {
        console.warn("No data available for export.");
        this.setError('noExportData');
        return;
      }

      var headers = [];
      var rows = [];
      // Define custom headers
      if(this.isAutofit) {
        headers = ['materialName', 'thickness', 'boards', 'jobs', 'machines', 'parts'].map(field => this.$t(`detail.fields.${field}`)).join(",");

        // Map data to match the headers
        rows = this.resultArray.map(row =>
            [
                `"${row.materialName}"`,
                `"${row.thickness}"`,
                `"${row.recordCount}"`,
                `"${row.uniqueDocumentIds}"`,
                `"${row.uniqueMachines}"`,
                `"${row.onderdelen}"`
            ].join(",")
        );
      }
      else {
        headers = ['materialName', 'thickness', 'parts', 'jobs', 'productionMethod'].map(field => this.$t(`detail.fields.${field}`)).join(",");

        // Map data to match the headers
        rows = this.resultArray.map(row =>
            [
                `"${row.materialName}"`,
                `"${row.thickness}"`,
                `"${row.recordCount}"`,
                `"${row.uniqueDocumentIds}"`,
                `"${row.productionmethod}"`
            ].join(",")
        );
      }

      // Join headers and rows
      const csvContent = [headers, ...rows].join("\n");

      // Create a Blob and trigger the download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportCSV() {
      console.log("exportCSV");
      this.clearError();
      const now = new Date();
      const offset = now.getTimezoneOffset(); // Offset in minutes
      const localTime = new Date(now.getTime() - offset * 60000); // Convert UTC to local
      const formattedDate = localTime.toISOString().slice(0, 19).replace("T", "_").replace(/:/g, "-");
      const filename = `${this.$t('detail.exportFilename')}_${formattedDate}`;
      console.log("filename: " + filename);

      if (!this.data || this.data.length === 0) {
        console.warn("No data available for export.");
        this.setError('noExportData');
        return;
      }

      var headers = [];
      var rows = [];
      // Define custom headers
      if(this.isAutofit) {
        headers = ['id', 'client', 'parts', 'boards', 'commission'].map(field => this.$t(`detail.fields.${field}`)).join(",");

        // Map data to match the headers
        rows = this.data.map(row =>
            [
                `"${row.id}"`,
                `"${row.client}"`,
                `"${row.total_qty}"`,
                `"${row.recordCount}"`,
                `"${row.commission}"`
            ].join(",")
        );
      }
      else {
        headers = ['id', 'client', 'parts', 'commission'].map(field => this.$t(`detail.fields.${field}`)).join(",");

        // Map data to match the headers
        rows = this.data.map(row =>
            [
                `"${row.id}"`,
                `"${row.client}"`,
                `"${row.total_qty}"`,
                `"${row.commission}"`
            ].join(",")
        );
      }

      // Join headers and rows
      const csvContent = [headers, ...rows].join("\n");

      // Create a Blob and trigger the download
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async onRowSelect() {
      console.log("onRowSelect");
      this.clearError();
      console.log("selectId: " + JSON.stringify(this.selectId));
      const application = localStorage.getItem("application") || null;
      this.visibleOverzicht = true;
      var documentIds = this.selectId.id;

      if(application === "AutoFIT") {
        await axios.get(this.baseUrl+"api/getAllCompositionsByDocumentIds/"+documentIds)
        .then((res) => {
          console.log("res: " + JSON.stringify(res));
          if(res.status === 200) {
            const grouped = res.data.reduce((acc, item) => {
              const key = `${item.materialname}-${item.materialthickness}`;
              if (!acc[key]) {
                acc[key] = { 
                  materialname: item.materialname, 
                  thickness: item.materialthickness, 
                  aantal: 0,
                  documentIds: new Set(),
                  machinesIds: new Set(),
                  grossTotal: 0, 
                  netTotal: 0,
                  restTotal: 0,
                  scrapTotal: 0,
                  cuttingTotal: 0,
                  onderdelen: 0
                };
              }
              acc[key].aantal += 1;
              acc[key].documentIds.add(item.documentid);
              acc[key].machinesIds.add(item.sawused);
              acc[key].grossTotal += item.gross;
              acc[key].netTotal += item.net;
              acc[key].restTotal += item.rest;
              acc[key].scrapTotal += item.waste;
              acc[key].cuttingTotal += (item.sawlength*item.optimdistance);
              acc[key].onderdelen += (item.partqty*item.qty);
              return acc;
            }, {});

            const result2 = Object.values(grouped).map(item => ({
              materialName: item.materialname,
              thickness: item.thickness,
              recordCount: item.aantal,
              uniqueDocumentIds: item.documentIds.size,
              uniqueMachines: item.machinesIds.size,
              percentageNet: parseFloat(((item.netTotal / item.grossTotal) * 100).toFixed(2)),
              percentageRest: parseFloat(((item.restTotal / item.grossTotal) * 100).toFixed(2)),
              percentageScrap: parseFloat(((item.scrapTotal / item.grossTotal) * 100).toFixed(2)),
              percentageCutting: parseFloat(((item.cuttingTotal / item.grossTotal) * 100).toFixed(2)),
              onderdelen: item.onderdelen
            }));
            this.resultArray = result2;

            var totNet = 0;
            var totRest = 0;
            var totScrap = 0;
            var totCutting = 0;

            res.data.forEach(item => {
              totNet += (item.net/item.gross)*100;
              totRest += (item.rest/item.gross)*100;
              totScrap += (item.waste/item.gross)*100;
              totCutting += ((item.sawlength*item.optimdistance)/item.gross)*100;
            });
            
            this.net = totNet / res.data.length;
            this.rest = totRest / res.data.length;
            this.scrap = totScrap / res.data.length;
            this.cutting = totCutting / res.data.length;
            console.log("net: " + this.net);
            console.log("rest: " + this.rest);
            console.log("scrap: " + this.scrap);
            console.log("cutting: " + this.cutting);
          }
        })
        .catch((err) => {
          console.log("getAllCompositionsByDocumentIds error: " + JSON.stringify(err));
          this.setError(err.request ? 'network' : 'compositionLoadFailed');
        });
      }
      else {
        await axios.get(this.baseUrl+"api/getAllProductionPartsByDocumentIds/"+documentIds)
        .then(async (res) => {
          console.log("res: " + JSON.stringify(res));
          if(res.status === 200) {
            // groeperen op prod.methode
            const groupedPM = res.data.reduce((accPM, item) => {
              const keyPM = `${item.productionmethod}`;
              if (!accPM[keyPM]) {
                accPM[keyPM] = {
                  productionmethod: item.productionmethod,
                  aantalPM: 0
                };
              }
              accPM[keyPM].aantalPM += 1;
              return accPM;
            }, {});
            console.log("groupedPM: " + JSON.stringify(groupedPM));

            // Stap 2: Omzetten naar array
            const resultPM = Object.values(groupedPM).map(item => ({
              productionmethod: item.productionmethod,
              recordCountPM: item.aantalPM,
            }));

            console.log("resultPM: " + JSON.stringify(resultPM));
            var totaalPM = 0;
            resultPM.forEach(item => {
              totaalPM += item.recordCountPM
            });
            console.log("totaalPM: " + totaalPM);

            this.labelsDoughnutKorpus = resultPM.map(item => item.productionmethod);
            console.log("labelsDoughnutKorpus: " + this.labelsDoughnutKorpus);
            this.dataDoughnutKorpus = resultPM.map(item => parseFloat(((item.recordCountPM/totaalPM)*100).toFixed(2)));
            console.log("dataDoughnutKorpus: " + this.dataDoughnutKorpus);

            // Stap 1: Groeperen op materialname en thickness
            const grouped = res.data.reduce((acc, item) => {
              const key = `${item.materialname}-${item.materialthickness}`;
              if (!acc[key]) {
                acc[key] = { 
                  materialname: item.materialname, 
                  thickness: item.materialthickness, 
                  aantal: 0,
                  documentIds: new Set(),
                  sizex: 0,
                  sizey: 0,
                  productionmethod: item.productionmethod,
                  dd3: 0,
                  dd4: 0,
                  dd5: 0,
                  dd8: 0,
                  dd10: 0,
                  dd12: 0,
                  dd15: 0,
                  dd20: 0,
                  dd25: 0,
                  dd35: 0
                };
              }
              acc[key].aantal += 1;
              acc[key].documentIds.add(item.documentid);
              acc[key].sizex += item.sizex;
              acc[key].sizey += item.sizey;
              acc[key].dd3 += item.dd3;
              acc[key].dd4 += item.dd4;
              acc[key].dd5 += item.dd5;
              acc[key].dd8 += item.dd8;
              acc[key].dd10 += item.dd10;
              acc[key].dd12 += item.dd12;
              acc[key].dd15 += item.dd15;
              acc[key].dd20 += item.dd20;
              acc[key].dd25 += item.dd25;
              acc[key].dd35 += item.dd35;
              return acc;
            }, {});
            console.log("grouped: " + JSON.stringify(grouped));

            // Stap 2: Omzetten naar array en perc berekenen
            const result2 = Object.values(grouped).map(item => ({
              materialName: item.materialname,
              thickness: item.thickness,
              recordCount: item.aantal,
              uniqueDocumentIds: item.documentIds.size,
              sizex: (item.sizex/item.aantal),
              sizey: (item.sizey/item.aantal),
              productionmethod: item.productionmethod,
              dd3: item.dd3,
              dd4: item.dd4,
              dd5: item.dd5,
              dd8: item.dd8,
              dd10: item.dd10,
              dd12: item.dd12,
              dd15: item.dd15,
              dd20: item.dd20,
              dd25: item.dd25,
              dd35: item.dd35,
            }));
            this.resultArray = result2;
          }
        })
        .catch((err) => {
          console.log("getAllCompositionsByDocumentIds error: " + JSON.stringify(err));
          this.setError(err.request ? 'network' : 'productionPartsLoadFailed');
        });
      }
    },
    onRowUnselect() {
      console.log("onRowUnselect");
      this.selectId = null;
    },
    onHide() {
      this.onRowUnselect();
      this.$emit('update:show', false); // Update de parent component
    },
    onHideOverzicht() {
      this.visibleOverzicht = false;
    },
    async getDetailsData() {
      console.log("getDetailsData");
      this.clearError();
      const customerId = localStorage.getItem("customerId") || null;
      const application = localStorage.getItem("application") || null;
      const year = localStorage.getItem("year") || null;
      const month = localStorage.getItem("month") || null;
      const activeButton = localStorage.getItem("activeButton") || null;
      const activeDate = localStorage.getItem("activeDate") || null;
      console.log("customerId: " + customerId);
      console.log("application: " + application);
      var selectionValue = "";
      this.isAutofit = false;
      if(application === "AutoFIT") {
        this.isAutofit = true;
      }
      if(activeButton === "month") {
        var date = new Date("01" + month + year);
        selectionValue = (date.getMonth()+1);
      }
      else {
        selectionValue = month;
      }
      try {
        const res = await axios.get(this.baseUrl+"api/getAllDocumentsBySelection/"+customerId+"/"+year+"/"+application+"/"+activeDate+"/"+activeButton+"/"+selectionValue);
        console.log("getAllDocumentsBySelection res: " + JSON.stringify(res.data));
        const result = res.data.filter(item => item.total_qty !== null);
        console.log("filter res: " + JSON.stringify(result));
        this.data = result;
      }
      catch (err) {
        console.log("getAllDocumentsBySelection error: " + JSON.stringify(err));
        this.setError(err.request ? 'network' : 'documentsLoadFailed');
      }
    }
  }
}
</script>
<style scoped>
.content {
  width: 100%;
}

.content-gray {
  width: min(100%, 75rem);
  margin-inline: auto;
  padding: clamp(0.75rem, 2vw, 1.5rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-medium);
  background: var(--color-background);
}

.content-gray-top {
  width: 100%;
  padding: 0.5rem;
  border-radius: var(--radius-medium);
  background: var(--color-surface);
}

.detail-overview-table {
  margin-top: 1rem;
}

.error {
  display: block;
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  color: #ffffff;
  border-radius: var(--radius-small);
  background: var(--color-error);
}

@media (max-width: 48rem) {
  .content-gray {
    padding: 0.5rem;
  }
}
</style>
